import { render, staticRenderFns } from "./ReturnStatusBadge.vue?vue&type=template&id=b7a18790&"
import script from "./ReturnStatusBadge.vue?vue&type=script&lang=js&"
export * from "./ReturnStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./ReturnStatusBadge.vue?vue&type=style&index=0&id=b7a18790&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports